<template>
  <div class="compras-container">
    <div class="row">
      <!-- Contenido principal -->
      <div class="col-12">
        <!-- Sección superior con datos generales -->
        <div class="card mb-3">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-2">
                <label class="form-label">Tipo</label>
                <select class="form-select compras-field">
                  <option value="C">Compra</option>
                  <option value="V">Venta</option>
                  <option value="T">Traspaso</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">C. Transacción</label>
                <select class="form-select compras-field">
                  <option>Compra Directa</option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="form-label">Int/Ext</label>
                <div class="form-check form-switch mt-2">
                  <input class="form-check-input" type="checkbox" id="intExtSwitch">
                  <label class="form-check-label" for="intExtSwitch">Ext</label>
                </div>
              </div>
              <div class="col-md-2">
                <label class="form-label">Folio</label>
                <input type="text" class="form-control compras-field" value="P-13">
              </div>
              <div class="col-md-3">
                <label class="form-label">Fecha</label>
                <input type="date" class="form-control compras-field" value="2025-01-08">
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-3">
                <label class="form-label">No. Viaje DTS</label>
                <input type="text" class="form-control compras-field" value="24419">
              </div>
              <div class="col-md-3">
                <label class="form-label">Unidad</label>
                <select class="form-select compras-field">
                  <option>120 :: Internacional</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Operador</label>
                <select class="form-select compras-field">
                  <option>1001 :: Juan Perez</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Folio SAP</label>
                <input type="text" class="form-control compras-field" value="100019182">
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-3">
                <label class="form-label">Contenedor</label>
                <select class="form-select compras-field">
                  <option>SR-234</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Ref. Bascula</label>
                <input type="text" class="form-control compras-field" value="13683679">
              </div>
              <div class="col-md-3">
                <label class="form-label">Ref 2</label>
                <input type="text" class="form-control compras-field" value="237587">
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <label class="form-label">Comentarios</label>
                <textarea class="form-control compras-field" rows="2" placeholder="PLACAS: EX261B TOLVA: SR-234"></textarea>
              </div>
            </div>
          </div>
        </div>

        <!-- Sección de Proveedor -->
        <div class="card mb-3">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-8">
                <label class="form-label">Proveedor</label>
                <div class="input-group">
                  <select class="form-select compras-field">
                    <option>PCH14-0197 :: GRUPO COLLADO SA DE CV (MTY-OTOMI)</option>
                  </select>
                  <button class="btn btn-outline-secondary" type="button">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">Tipo Lista</label>
                <select class="form-select compras-field">
                  <option>Especial</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabla de Artículos -->
        <div class="card">
          <div class="card-body">
            <table class="table table-bordered">
              <thead class="table-light">
                <tr>
                  <th width="5%">#</th>
                  <th width="40%">Artículo</th>
                  <th width="15%">KG</th>
                  <th width="15%">Precio</th>
                  <th width="10%">MN</th>
                  <th width="15%">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1.</td>
                  <td>
                    <select class="form-select compras-field">
                      <option>CH-0003 :: MIXTO</option>
                    </select>
                  </td>
                  <td><input type="number" class="form-control compras-field" value="8340.00" step="0.01"></td>
                  <td><input type="number" class="form-control compras-field" value="3.50" step="0.01"></td>
                  <td>MN</td>
                  <td class="text-end">$29,190.00</td>
                </tr>
                <tr>
                  <td>2.</td>
                  <td>
                    <select class="form-select compras-field">
                      <option>CH-0005 :: PLACA Y ESTRUCTURA</option>
                    </select>
                  </td>
                  <td><input type="number" class="form-control compras-field" value="400.00" step="0.01"></td>
                  <td><input type="number" class="form-control compras-field" value="4.30" step="0.01"></td>
                  <td>MN</td>
                  <td class="text-end">$1,720.00</td>
                </tr>
                <tr>
                  <td>3.</td>
                  <td>
                    <select class="form-select compras-field">
                      <option>CH-0006 :: RI GALVANIZADO</option>
                    </select>
                  </td>
                  <td><input type="number" class="form-control compras-field" value="200.00" step="0.01"></td>
                  <td><input type="number" class="form-control compras-field" value="4.10" step="0.01"></td>
                  <td>MN</td>
                  <td class="text-end">$820.00</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-success">
                  <td colspan="2" class="text-end"><strong>TOTAL</strong></td>
                  <td><strong>8,940.00 KG</strong></td>
                  <td colspan="2"></td>
                  <td class="text-end"><strong>$31,730.00</strong></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>



      <!-- Sección de Pesos -->
      <div class="row mt-4">
        <div class="col-12">
          <div class="card" style="border: 2px solid #4a90e2; border-radius: 15px; background-color: #f8f9fa;">
            <div class="card-body p-3">
              <div class="row">
                <!-- Columna izquierda - Pesos -->
                <div class="col-8">
                  <div class="row mb-2">
                    <div class="col-3">
                      <button class="btn btn-info btn-sm w-100" style="background-color: #17a2b8; border: none;">1er Peso</button>
                    </div>
                    <div class="col-3">
                      <span class="fw-bold">21,620.00 KG</span>
                    </div>
                    <div class="col-3">
                      <span class="text-muted">NONE</span>
                    </div>
                    <div class="col-3">
                      <span class="text-muted">08/07/2025 03:30p.m.</span>
                    </div>
                  </div>
                  
                  <div class="row mb-2">
                    <div class="col-3">
                      <button class="btn btn-info btn-sm w-100" style="background-color: #17a2b8; border: none;">2do Peso</button>
                    </div>
                    <div class="col-3">
                      <span class="fw-bold">12,580.00 KG</span>
                    </div>
                    <div class="col-3">
                      <span class="text-muted">NONE</span>
                    </div>
                    <div class="col-3">
                      <span class="text-muted">08/07/2025 03:30p.m.</span>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-3">
                      <span class="fw-bold">Peso Neto</span>
                    </div>
                    <div class="col-3">
                      <span class="fw-bold">9,040.00 KG</span>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-3">
                      <span class="fw-bold">Deducción</span>
                    </div>
                    <div class="col-3">
                      <span class="fw-bold">100.00 KG</span>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-3">
                      <span class="fw-bold">Peso Ajustado</span>
                    </div>
                    <div class="col-3">
                      <span class="fw-bold">8,940.00 KG</span>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-3">
                      <span class="fw-bold">Peso SN</span>
                    </div>
                    <div class="col-3">
                      <span class="fw-bold">8,920.00 KG</span>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-6">
                      <div class="d-flex align-items-center">
                        <span class="fw-bold me-3">Peso Boleta</span>
                        <span class="badge" style="background-color: #ffc107; color: #000; font-size: 14px; padding: 8px 15px;">8,940.00 KG</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Columna derecha - Botones de acción -->
                <div class="col-4">
                  <div class="d-flex flex-column gap-2">
                    <button class="btn btn-info" style="background-color: #17a2b8; border: none;">Desvío</button>
                    <button class="btn btn-info" style="background-color: #17a2b8; border: none;">Editar</button>
                    <button class="btn btn-info" style="background-color: #17a2b8; border: none;">Escanear</button>
                    
                    <!-- Panel de información COMPRA -->
                    <div class="mt-3 p-3" style="background-color: #d6d8db; border-radius: 8px;">
                      <div class="text-center mb-2">
                        <span class="fw-bold">COMPRA</span>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <small class="fw-bold">F. Entrada</small>
                        </div>
                        <div class="col-6">
                          <small>100019182</small>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <small class="fw-bold">F. Devolución</small>
                        </div>
                        <div class="col-6">
                          <small>100007251</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Barra inferior con información de usuario -->
      <div class="row mt-3">
        <div class="col-12">
          <div class="d-flex justify-content-center align-items-center p-2" style="background-color: #d6d8db; border-radius: 5px;">
            <span class="me-4"><strong>Usuario:</strong> manager</span>
            <span><strong>BD:</strong> DIMECA_2011</span>
          </div>
        </div>
      </div>

      <!-- Botones de acción inferiores -->
      <div class="row mt-3 mb-4">
        <div class="col-12">
          <div class="d-flex justify-content-center gap-3">
            <button class="btn btn-info px-4" style="background-color: #17a2b8; border: none;">Actualizar</button>
            <button class="btn btn-info px-4" style="background-color: #17a2b8; border: none;">Ticket</button>
            <button class="btn btn-info px-4" style="background-color: #17a2b8; border: none;">Remisión</button>
            <button class="btn btn-info px-4" style="background-color: #17a2b8; border: none;">Buscar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'

export default {
  name: 'Posw2ComprasView',
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      // Datos del formulario de compras
      formData: {
        tipo: 'Compra',
        transaccion: 'Compra Directa',
        isExterno: true,
        folio: 'P-13',
        fecha: '2025-01-08',
        noViaje: '24419',
        unidad: '120 :: Internacional',
        operador: '1001 :: Juan Perez',
        folioSAP: '100019182',
        contenedor: 'SR-234',
        refBascula: '13683679',
        ref2: '237587',
        comentarios: 'PLACAS: EX261B TOLVA: SR-234'
      },
      isEditing: false,
      hasUnsavedChanges: false
    }
  },
  mounted() {
    // Mostrar la barra de acciones para esta vista
    this.$emitter.emit('show-form-action-bar', {
      showNew: true,
      showSave: true,
      showEdit: true,
      showRefresh: false,
      showDelete: true,
      showCancel: true,
      showPrint: true,
      saveDisabled: !this.isEditing,
      editDisabled: this.isEditing,
      cancelDisabled: !this.isEditing
    });
    
    // Escuchar eventos globales de la barra de acciones
    this.$emitter.on('form-action', this.handleFormAction);
    this.$emitter.on('custom-form-action', this.handleCustomAction);
  },
  beforeUnmount() {
    // Ocultar la barra de acciones al salir de la vista
    this.$emitter.emit('hide-form-action-bar');
    
    // Limpiar listeners
    this.$emitter.off('form-action', this.handleFormAction);
    this.$emitter.off('custom-form-action', this.handleCustomAction);
  },
  methods: {
    handleFormAction(action) {
      // Solo procesar si estamos en esta vista
      if (this.$route.path !== '/posw2/compras') return;
      
      switch (action) {
        case 'new':
          this.nuevoRegistro();
          break;
        case 'save':
          this.guardarCompra();
          break;
        case 'edit':
          this.editarCompra();
          break;
        case 'delete':
          this.eliminarCompra();
          break;
        case 'cancel':
          this.cancelarEdicion();
          break;
        case 'print':
          this.imprimirCompra();
          break;
      }
    },
    handleCustomAction(actionKey) {
      // Manejar acciones personalizadas si las hay
      console.log('Acción personalizada:', actionKey);
    },
    nuevoRegistro() {
      alert("Nuevo");
      if (this.hasUnsavedChanges) {
        if (!confirm('¿Desea descartar los cambios no guardados?')) {
          return;
        }
      }
      // Limpiar formulario para nuevo registro
      this.formData = {
        tipo: 'Compra',
        transaccion: 'Compra Directa',
        isExterno: false,
        folio: '',
        fecha: new Date().toISOString().split('T')[0],
        noViaje: '',
        unidad: '',
        operador: '',
        folioSAP: '',
        contenedor: '',
        refBascula: '',
        ref2: '',
        comentarios: ''
      };
      this.isEditing = true;
      this.hasUnsavedChanges = false;
      this.updateActionBarState();
      console.log('Nuevo registro iniciado');
    },
    guardarCompra() {
      // Validar datos antes de guardar
      if (!this.validarFormulario()) {
        alert('Por favor complete todos los campos requeridos');
        return;
      }
      
      // Simular guardado
      console.log('Guardando compra:', this.formData);
      
      // Aquí iría la lógica para enviar al backend
      setTimeout(() => {
        alert('Compra guardada exitosamente');
        this.hasUnsavedChanges = false;
        this.isEditing = false;
        this.updateActionBarState();
      }, 500);
    },
    editarCompra() {
      this.isEditing = true;
      this.updateActionBarState();
      console.log('Modo edición activado');
    },
    eliminarCompra() {
      if (confirm('¿Está seguro de que desea eliminar esta compra?')) {
        console.log('Eliminando compra');
        // Aquí iría la lógica para eliminar del backend
        alert('Compra eliminada');
      }
    },
    cancelarEdicion() {
      if (this.hasUnsavedChanges) {
        if (!confirm('¿Desea descartar los cambios no guardados?')) {
          return;
        }
      }
      this.isEditing = false;
      this.hasUnsavedChanges = false;
      this.updateActionBarState();
      console.log('Edición cancelada');
    },
    imprimirCompra() {
      console.log('Imprimiendo compra');
      // Aquí iría la lógica para generar e imprimir el documento
      window.print();
    },
    validarFormulario() {
      // Validaciones básicas
      return this.formData.folio && 
             this.formData.fecha && 
             this.formData.noViaje;
    },
    // Métodos para los botones específicos de la vista
    actualizarDatos() {
      console.log('Actualizando datos');
      // Lógica para actualizar datos desde el servidor
    },
    generarTicket() {
      console.log('Generando ticket');
      // Lógica para generar ticket
    },
    generarRemision() {
      console.log('Generando remisión');
      // Lógica para generar remisión
    },
    buscarCompra() {
      console.log('Buscando compra');
      // Lógica para buscar compras
    },
    updateActionBarState() {
      // Actualizar el estado de los botones según el modo actual
      this.$emitter.emit('update-form-action-bar', {
        saveDisabled: !this.isEditing,
        editDisabled: this.isEditing,
        cancelDisabled: !this.isEditing
      });
    }
  }
}
</script>

<style scoped>
.compras-container {
  padding: 20px;
}

.compras-title {
  font-size: 2rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 30px;
}

.compras-field {
  background-color: #e8f5e8;
  border: 1px solid #c3e6c3;
}

.compras-field:focus {
  background-color: #e8f5e8;
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.card {
  border: 2px solid #007bff;
  border-radius: 15px;
}

.table-bordered {
  border: 2px solid #007bff;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #007bff;
}

.form-check-input:checked {
  background-color: #28a745;
  border-color: #28a745;
}

.btn-outline-secondary {
  border-color: #c3e6c3;
}

.btn-outline-secondary:hover {
  background-color: #28a745;
  border-color: #28a745;
}
</style>